const colors = {
	// colorPrimary: '#ca0c0b',
	colorPrimary: '#07588f',
	colorSecondary: '#16b2b0',
	// colorText: '#e7eef8',
	// colorGray: '#989898',
	// colorLight: 'rgba(0, 0, 0, 0.0375)',
	// colorBlack: '#05050B',
	// colorLightBlack: '#19191F',
	// colorTextDark: '#323232',
	// colorDarkBlue: '#4D69FA',
	// colorDimBlack: '#35363A',
	// colorDimBlack1: 'rgb(53,54,58, 0.95)',
	// colorInput: '#F9F9F9',

};

export default colors;
